import socketIoAPI from '@/modules/socketAPI.js'
import vueAPI from '@/modules/vueAPI.js'
import globalFunctions from '@/packages/globalFunctions.js'

socketIoAPI.onNewConnection(function(socketVar) {
    vueAPI.onMounted(function(thisVue) {
        if (thisVue.$store.state.loginData.adminLoggedIn) {
            globalFunctions.tech.getSiteLanguages()
        }
    })

    socketVar.on('meLoggedIn', function() {
        globalFunctions.tech.getSiteLanguages()
    })
})